import { FunctionComponent, useState, useCallback, useEffect } from 'react';
import {
  Query,
  Builder,
  Utils as QbUtils,
  JsonTree,
} from 'react-awesome-query-builder';
import 'react-awesome-query-builder/lib/css/styles.css';
import 'react-awesome-query-builder/lib/css/compact_styles.css';
import MuiConfig from 'react-awesome-query-builder/lib/config/mui';
import styled from 'styled-components';
import { FIELD_SEPARATOR } from 'constants/constants';
import { isEmpty } from 'utils';
const InitialConfig = MuiConfig;
InitialConfig.settings.showNot = false;
InitialConfig.settings.fieldSeparator = FIELD_SEPARATOR;
InitialConfig.settings.fieldSeparatorDisplay = '.';

const OPERATORS = ['equal', 'not_equal', 'like', 'not_like'];

export const CONFIG: any = {
  ...InitialConfig,
  fields: {
    url: {
      label: 'url',
      type: 'text',
      valueSources: ['value'],
      operators: OPERATORS,
    },
  },
};

const QBStyles = styled('div')`
  .group {
    & > .group--header {
      .group--conjunctions {
        display: none;
      }
    }
  }
  .group--actions--tr button:last-child {
    display: none;
  }
`;

const EMPTY_RECIPE: JsonTree = {
  type: 'group',
  id: 'bb89ba8b-89ab-4cde-b012-3183699f09e4',
  children1: [
    {
      type: 'rule',
      properties: {
        field: null,
        operator: null,
        value: [],
        valueSrc: [],
      },
    },
  ],
  properties: {
    conjunction: 'AND',
    not: false,
  },
};

type Props = {
  onQBChange: Function;
  initRecipe?: any;
};

const PIUrlFilter: FunctionComponent<Props> = ({ onQBChange, initRecipe }) => {
  const [inputBuilderTree, setInputBuilderTree] = useState(
    QbUtils.checkTree(QbUtils.loadTree(EMPTY_RECIPE), CONFIG)
  );

  useEffect(() => {
    if (!isEmpty(initRecipe)) {
      const _inputBuilderTree = QbUtils.checkTree(
        QbUtils.loadTree(initRecipe),
        CONFIG
      );
      setInputBuilderTree(_inputBuilderTree);
    }
  }, [initRecipe]);

  const handleQBChange = useCallback(
    (immutableTree: any, config: any) => {
      const recipe_front = QbUtils.getTree(immutableTree);
      onQBChange(recipe_front);
      setInputBuilderTree(immutableTree);
    },
    [onQBChange]
  );

  const renderBuilder = useCallback(
    (props: any) => (
      <div className="query-builder-container">
        <div className="query-builder qb-lite" style={{ margin: 0 }}>
          <QBStyles>
            {/* 
                // @ts-ignore */}
            <Builder {...props} />
          </QBStyles>
        </div>
      </div>
    ),
    []
  );

  return (
    <>
      {/* 
    // @ts-ignore */}
      <Query
        {...CONFIG}
        value={inputBuilderTree}
        onChange={handleQBChange}
        renderBuilder={renderBuilder}
      />
    </>
  );
};

export default PIUrlFilter;
